export function maskPhoneNumber(phoneNumber) {
    // Convert the phone number to a string (in case it isn't already)
    phoneNumber = phoneNumber.toString();

    // Check if the phone number length is at least 10
    if (phoneNumber.length >= 10) {
        // Mask all but the last 4 digits
        let startPart = phoneNumber.slice(0,3);
        let maskedPart = phoneNumber.slice(3, -2).replace(/\d/g, '*');
        let visiblePart = phoneNumber.slice(-2);
        return startPart + maskedPart + visiblePart;
    } else {
        // If the phone number is too short, just return it as is
        return phoneNumber;
    }
}